

import React, { useState, useRef } from "react";

const galleryImages = [
  require("../assets/gall7.jpg"),
  require("../assets/gall3.jpg"),
  require("../assets/gall1.jpg"),
  require("../assets/gall2.jpg"),
  require("../assets/gall4.jpg"),
  require("../assets/gall5.jpg"),
  require("../assets/gall6.jpg"),
 
];

export default function Gallery() {
  const [showAll, setShowAll] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const videoRef = useRef(null);

  const imagesToShow = showAll ? galleryImages : galleryImages.slice(0, 6);

  const toggleVideo = () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) videoRef.current.play();
    else videoRef.current.pause();
  };

  return (
    <section
      id="gallery"
      className="py-20 bg-gradient-to-tr from-red-100 via-pink-100 to-red-200 relative overflow-hidden"
    >
      {/* Glow effects */}
      <div className="absolute top-10 left-10 w-60 h-60 bg-red-300/30 blur-[100px] rounded-full"></div>
      <div className="absolute bottom-20 right-10 w-72 h-72 bg-pink-300/30 blur-[120px] rounded-full"></div>

      <div className="max-w-7xl mx-auto px-6 relative">
        <h2 className="text-4xl font-extrabold mb-12 text-red-800 tracking-wide">
          Gallery
        </h2>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

          {/* LEFT: IMAGE GRID */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
            {imagesToShow.map((img, i) => (
              <div
                key={i}
                className="relative overflow-hidden rounded-2xl shadow-lg cursor-pointer group border-4 border-red-600 transition-all duration-300 hover:shadow-2xl"
                onClick={() => setModalImage(img)}
              >
                <img
                  src={img}
                  alt={`gallery-${i}`}
                  loading="lazy"
                  className="w-full h-full aspect-[4/3] object-cover transition-transform duration-500 group-hover:scale-110"
                />

                <div className="absolute inset-0 bg-red-600/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10l4.553-2.276A1 1 0 0119 8.618v6.764a1 1 0 01-1.447.894L15 14m-6 0l-4.553 2.276A1 1 0 015 15.382V8.618a1 1 0 011.447-.894L9 10m6 0v4a2 2 0 11-4 0v-4"
                    />
                  </svg>
                </div>
              </div>
            ))}
          </div>

 
     

{/* RIGHT: VIDEO */}
<div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-red-600">
  <video
    ref={videoRef}
    src={require("../assets/video.mp4")}
    loop
    playsInline
    onClick={toggleVideo}
    className="w-full h-full object-cover rounded-2xl cursor-pointer"
  />

  {/* Overlay */}
  <div className="absolute inset-0 flex items-end justify-center bg-black/20 pointer-events-none">
    <div className="p-6 text-blue-600 text-center">
      <h3 className="text-2xl font-bold">
        Labtouch Pathology Lab
      </h3>
      <p className="text-sm opacity-90 text-green-600 font-bold">
        Modern equipment • Trusted results • Hygienic process
      </p>
    </div>
  </div>
</div>

        </div>

        {/* VIEW ALL BUTTON */}
        {!showAll && (
          <div className="flex justify-center mt-12">
            <button
              onClick={() => setShowAll(true)}
              className="px-8 py-3 bg-red-600 text-white font-semibold rounded-xl shadow-lg hover:bg-red-700 transition-all"
            >
              View All Photos
            </button>
          </div>
        )}

        {/* ===== MODAL ===== */}
        {modalImage && (
          <div
            className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
            onClick={() => setModalImage(null)}
          >
            <img
              src={modalImage}
              alt="fullscreen"
              className="max-w-full max-h-full rounded-xl shadow-2xl object-contain"
              onClick={(e) => e.stopPropagation()}
            />
            <button
              onClick={() => setModalImage(null)}
              className="absolute top-5 right-5 text-white text-3xl font-bold"
            >
              &times;
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
